import {database} from './fire'

export function saveUserPublicData(userID, publicData) {
    const {startTime, date, timesCompleted, completedAt} = publicData
    return database.ref('users/' + userID).update({
        timesCompleted: timesCompleted + 1,
        completedAt: {...completedAt, [date]: startTime}
    })
}

export function saveUserContactData(userID, userContactData) {
    return database.ref('userContactData/' + userID )
        .set(userContactData)
}